import { Box, Button, ButtonGroup, Typography } from "@mui/material";
import { useState } from "react";
import { LikertScale } from "./LikertScale";

export type panasAnsewerType = {
  // positive
  attentive: number | null;
  active: number | null;
  alert: number | null;
  excited: number | null;
  enthusiastic: number | null;
  determined: number | null;
  inspired: number | null;
  proud: number | null;
  interested: number | null;
  strong: number | null;
  // negative
  hostile: number | null;
  irritable: number | null;
  ashamed: number | null;
  guilty: number | null;
  distressed: number | null;
  upset: number | null;
  scared: number | null;
  afraid: number | null;
  jittery: number | null;
  nervous: number | null;
};

export const defaultPanasAnswer: panasAnsewerType = {
  attentive: null,
  active: null,
  alert: null,
  excited: null,
  enthusiastic: null,
  determined: null,
  inspired: null,
  proud: null,
  interested: null,
  strong: null,
  hostile: null,
  irritable: null,
  ashamed: null,
  guilty: null,
  distressed: null,
  upset: null,
  scared: null,
  afraid: null,
  jittery: null,
  nervous: null,
};

interface PanasProps {
  panasAnswer: panasAnsewerType;
  setPanasAnswer: React.Dispatch<React.SetStateAction<panasAnsewerType>>;
}

export const Panas: React.FC<PanasProps> = ({
  panasAnswer,
  setPanasAnswer,
}) => {
  const handleChange = (key: keyof panasAnsewerType, value: number) => {
    setPanasAnswer((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const spaceHeight = "0.75rem";

  return (
    <>
      <Box sx={{ padding: "1rem" }}>
        <Typography variant="body1">※この設問は初日のみ回答頂きます</Typography>
        <div style={{ height: "1rem" }} />
        <Typography variant="caption">
          以下に状態を表す語がいくつか表されています。現在のあなたの気分にどれほどあてはまるか
          「1.まったく当てはまらない」、「2.当てはまらない」、「3.どちらかといえば当てはまらない」、
          「4.どちらかといえば当てはまる」、「5.当てはまる」、「6.非常によく当てはまる」の中から
          最も適当なものを選び回答してください。
        </Typography>
        <div style={{ height: "1rem" }} />
        <Typography variant="body2">神経質な</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.nervous}
          onChange={(value) => handleChange("nervous", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">活気のある</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.active}
          onChange={(value) => handleChange("active", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">おびえた</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.afraid}
          onChange={(value) => handleChange("afraid", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">誇らしい</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.proud}
          onChange={(value) => handleChange("proud", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">うろたえた</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.upset}
          onChange={(value) => handleChange("upset", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">恐れた</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.scared}
          onChange={(value) => handleChange("scared", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">強気な</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.strong}
          onChange={(value) => handleChange("strong", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">興奮した</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.excited}
          onChange={(value) => handleChange("excited", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">ぴりぴりした</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.jittery}
          onChange={(value) => handleChange("jittery", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">決心した</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.determined}
          onChange={(value) => handleChange("determined", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">苦悩した</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.distressed}
          onChange={(value) => handleChange("distressed", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">やる気がわいた</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.inspired}
          onChange={(value) => handleChange("inspired", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">機敏な</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.alert}
          onChange={(value) => handleChange("alert", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">熱狂した</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.enthusiastic}
          onChange={(value) => handleChange("enthusiastic", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">恥ずかしい</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.ashamed}
          onChange={(value) => handleChange("ashamed", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">イライラした</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.irritable}
          onChange={(value) => handleChange("irritable", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">興味のある</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.interested}
          onChange={(value) => handleChange("interested", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">うしろめたい</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.guilty}
          onChange={(value) => handleChange("guilty", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">敵意をもった</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.hostile}
          onChange={(value) => handleChange("hostile", value)}
        />

        <div style={{ height: spaceHeight }} />
        <Typography variant="body2">注意深い</Typography>
        <LikertScale
          likertLength={6}
          answerValue={panasAnswer.attentive}
          onChange={(value) => handleChange("attentive", value)}
        />
      </Box>
    </>
  );
};
